import { render, staticRenderFns } from "./BaiduContainer.vue?vue&type=template&id=6e71e900&scoped=true"
import script from "./BaiduContainer.vue?vue&type=script&lang=js"
export * from "./BaiduContainer.vue?vue&type=script&lang=js"
import style0 from "./BaiduContainer.vue?vue&type=style&index=0&id=6e71e900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71e900",
  null
  
)

export default component.exports